import Flex from '@Components/Bases/Flex';
import { Button } from '@mui/material';

const EditOperatingYearAction = ({
  onClose,
  isDisabled,
}: {
  onClose: () => void;
  isDisabled: boolean;
}) => (
  <Flex justifyContent={'end'} gap={2} p={2}>
    <Button onClick={onClose} variant="contained" color="inherit">
      ยกเลิก
    </Button>
    <Button
      variant="contained"
      color="primary"
      type="submit"
      disabled={isDisabled}
    >
      ยืนยัน
    </Button>
  </Flex>
);

export default EditOperatingYearAction;
